import {observer} from 'mobx-react';
import {Layout} from 'shared/components';
import {withState} from 'shared/core';
import PayrollNotEnabledState from '../state/PayrollNotEnabledState';
import InterestedInPayrollModal from './InterestedInPayrollModal';
import PayrollInfo from './PayrollInfo';

const PayrollNotEnabled = observer(({uiState}) => {
  return (
    <div>
      <Layout>
        <PayrollInfo uiState={uiState}/>
        <InterestedInPayrollModal uiState={uiState}/>
      </Layout>
    </div>
  );
});

export default withState(PayrollNotEnabled, PayrollNotEnabledState);
